import request from '@/utils/request'

//查询企业用户用量
export function getUeage() {
    return request({
        url: '/member/usage/get',
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/usage.js